// extracted by mini-css-extract-plugin
export var growableInput = "_a6-0";
export var tagContainer = "_a6-2";
export var textInput = "_a6-1";